import apiClient from "./apiClient";
import { LoginRequest } from "../models/RequestModels/LoginRequest";
import { LoginResponse } from "../models/ResponseModels/LoginResponse";
import { UpdateProfileRequest } from "../models/RequestModels/UpdateProfileRequest";
import { UpdateEmailRequest } from "../models/RequestModels/UpdateEmailRequest";
import { UpdatePasswordRequest } from "../models/RequestModels/UpdatePasswordRequest";
import { RegisterRequest } from "../models/RequestModels/RegisterRequest";
import { RegisterResponse } from "../models/ResponseModels/RegisterResponse";
import { ForgotPasswordRequest } from "../models/RequestModels/ForgotPasswordRequest";
import { SocialLoginRequest } from "../models/RequestModels/SocialLoginRequest";
import { FacebookLoginRequest } from "../models/RequestModels/FacebookLoginRequest";
import { ResetPasswordRequest } from "../models/RequestModels/ResetPasswordRequest";

export const loginRequest = async (
  body: LoginRequest,
): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>("/web/login", body);
  return response.data;
};

export const registerRequest = async (
  body: RegisterRequest,
): Promise<RegisterResponse> => {
  const response = await apiClient.post<RegisterResponse>("/register", body);
  return response.data;
};

export const forgotPasswordRequest = async (
  body: ForgotPasswordRequest,
): Promise<{ message: string }> => {
  const response = await apiClient.post<{ message: string }>(
    "/forgot-password",
    body,
  );

  return response.data;
};

export const googleLoginRequest = async (
  body: SocialLoginRequest,
): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>("/auth/google", body);
  return response.data;
};

export const facebookLoginRequest = async (
  body: FacebookLoginRequest,
): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>("/auth/facebook", body);
  return response.data;
};

export const meRequest = async (): Promise<Omit<LoginResponse, "token">> => {
  const response = await apiClient.get<Omit<LoginResponse, "token">>("/me");
  return response.data;
};

export const updateProfileRequest = async (
  body: UpdateProfileRequest,
): Promise<Omit<LoginResponse, "token">> => {
  const response = await apiClient.patch<Omit<LoginResponse, "token">>(
    "/profile",
    body,
  );

  return response.data;
};

export const updateEmailRequest = async (
  body: UpdateEmailRequest,
): Promise<Omit<LoginResponse, "token">> => {
  const response = await apiClient.patch<Omit<LoginResponse, "token">>(
    "/profile/email",
    body,
  );

  return response.data;
};

export const updatePasswordRequest = async (
  body: UpdatePasswordRequest,
): Promise<{ message: string }> => {
  const response = await apiClient.patch<{ message: string }>(
    "/profile/password",
    body,
  );

  return response.data;
};

export const resendVerificationEmailRequest = async (
  email: string,
): Promise<{ message: string }> => {
  const response = await apiClient.post<{ message: string }>(
    "/email/resend-verification",
    { email },
  );

  return response.data;
};

export const logoutRequest = async (): Promise<void> => {
  await apiClient.post("/logout");
};

export const resetPasswordRequest = async (
  body: ResetPasswordRequest,
): Promise<{ message: string }> => {
  const response = await apiClient.post<{ message: string }>(
    "/reset-password",
    body,
  );

  return response.data;
};
